export class AppConstants {
    public static readonly appVersion = 'app_version';

    public static readonly imageMaxSizeInKB = 500;
    public static readonly supportedImageType = '.png, .jpg, .jpeg';

    public static readonly communicationChannelImageMaxSizeInKB = 5000;

    // Language activation constants
    public static readonly isDeEnabled = true;
    public static readonly isItEnabled = false;
    public static readonly isEnEnabled = false;

    // LocalStorage Keys
    public static readonly languageKey = 'language';
    public static readonly pushPermissionAskedKey = 'push_permission_asked'; // Use to know if the user already answered the question
    public static readonly pushRegistrationTokenKey = 'push_registrationToken';
    public static readonly pushRegistrationEmailKey = 'push_registrationEmail';
}

export class AppRoles {
    public static readonly backoffice = 'Backoffice';
    public static readonly superAdmin = 'SuperAdmin';
    public static readonly customer = 'Customer';
}

export class PermissionKeys {
    public static readonly gestionBackoffices = 'GestionBackoffices';
    public static readonly gestionClients = 'GestionClients';
    public static readonly gestionCartes = 'GestionCartes';
    public static readonly exploitationCartes = 'ExploitationCartes';
    public static readonly gestionServices = 'GestionServices';
    public static readonly gestionTransactions = 'GestionTransactions';
    public static readonly gestionCommunication = 'GestionCommunication';
    public static readonly gestionInfrastructure = 'GestionInfrastructure';
    public static readonly gestionAlertesAlarmes = 'GestionAlertesAlarmes';
    public static readonly configurationAlertesAlarmes = 'ConfigurationAlertesAlarmes';
}

export const GesConstants = {
    defaultNumeralFormat: '0,0.00',
    intNumeralFormat: '0,0',
    defaultCurrencyFormat: '0,0.00 $',
};

export const CssConstants = {
    unlimitedRowHeightClass: 'unlimited-row-height',
    max150pxRowHeightClass: 'max-150px-row-height',
}

export enum TenantCodes  {
    Chevroux = 'cvx',
    Cheyres = 'ccc',
    Softcom = 'sftc',
    Neyruz = 'nrz',
    LeFlon = 'clf',
    Fribourg = 'vdf',
    Semsales = 'sem',
    Hauterive = 'hrfr',
    Portalban = 'por',
    Demo = 'demo',
    Villaz = 'cvf',
    Fetigny = 'fty',
    Lausanne = 'pdl',
    Estavayer = "esta",
    Sevaz = 'svz',
    CugyFR = 'cgy',
    LesMontets = 'lmt',
    RGRecuperation = 'gsz',
    LullyFR = 'lly',
    Cudrefin = 'cud',
    LaTene = 'tlt',
    Seod = 'seod',
    Revo = 'revo'
}
